import React, { useState } from "react";
import { CardView, SelectOption } from "../../../../controls";
import BarChartView from "../Other/BarChartView";
import { FaAngleDown } from "react-icons/fa6";
import "./CardStyles.scss";

const TopTechniciansCardCenterAdmin = (props) => {
  const chartData =
    props.data.length > 0 ? props.data : [{ label: "", count: 0 }];

  return (
    <div className="center-admin-half-width-cards-wrapper">
      <CardView
        extraStyle="top-performance-card-control"
        bodyStyle={{ height: "320px" }}
      >
        <div className="card-header">
          <div className="title">Top 5 Technicians by ECG Reports</div>
          <div className="dropdown-option-wrapper">
            <SelectOption
              options={props.filtersData}
              placeholder={"Select"}
              isSearchable={false}
              value={props.filterOptionSelected}
              onChange={(val) => {
                console.log("SELECT : ", val);
                props.onFilterOptionChange(val);
              }}
            />
          </div>
        </div>

        <div className="info-wrapper">
          <div className="bar-chart-wrapper">
            <BarChartView dataSet={chartData} theme="Purple" />
          </div>
        </div>
      </CardView>
    </div>
  );
};

export default TopTechniciansCardCenterAdmin;
